export class ArchivePressRelease {
	constructor($page) {
		this.$page = $page;
		this.$list = this.$page.find('.js-press-releases-wrapper');
		this.$more = this.$page.find('.js-more');
		this.ajaxInProgress = false;

		this.init();
	}

	init() {
		var self = this;

		self.$more.on('click', function() {
			self.more();
		});
	}

	more() {
		var self = this;

		if (!self.ajaxInProgress) {
			self.$page.addClass('loading');
			self.ajaxInProgress = true;
			$.ajax({
				url: window.sage.ajax['archive.press-release.more'],
				method: 'POST',
				data: {
					page: self.$more.data('next-page'),
					category: self.$more.data('category')
				},
				success: function(data) {
					self.$list.append(data.data.html);
					if (data.data.nextPage) {
						self.$more.data('next-page', data.data.nextPage);
					}
					else {
						self.$more.remove();
					}
					self.ajaxInProgress = false;
					self.$page.removeClass('loading');
				},
			}).fail(function(textStatus, errorThrown) {
				self.ajaxInProgress = false;
				self.$page.removeClass('loading');
				console.log(textStatus);
				console.log(errorThrown);
			});
		}
	}
}



// WEBPACK FOOTER //
// ./scripts/src/archive-press-release.js